export enum ChartLegendTheme {
  Primary = `primary`,
  CardList = `card-list`,
  CardTable = `card-table`,
  ReadOnly = `readonly`,
}

export const MAX_SEGMENTS_PER_COMPACT_TABLE_ROW = 3;
export const COMPACT_TABLE_LEGEND_LINE_HEIGHT = 28;
